import R from 'ramda';
import utils from './utils';
import { isTokenExpired, isTokenValid } from '../utilities/jwt';

angular.module('tct.ordersService', ['tct.ordersService'])
  .factory('ordersService', ordersService);

ordersService.$inject = ['configService', '$http'];

function ordersService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/orders`;
  const factory = {
    getOrders,
    placeOrderNational,
    placeOrderForeign,
    completeOrder,
    reopenOrder,
    getOrderedCompaniesOverview,
    updateInvestigationCodes,
    downloadReport,
    viewReportInBrowser,
  };

  function getOrders(type, params = {}) {
    const url = `${basePath}/${type}`;
    const formattedParams = {
      limit: params.limit || 10,
      page: params.page || 1,
    };
    const searchParamsObj = R.reduce(utils.withQueryParams, {}, R.toPairs(params));
    const completeParamObj = Object.assign({}, formattedParams, searchParamsObj);

    return $http.get(url, { params: completeParamObj });
  }

  function placeOrderNational(order) {
    const url = `${basePath}/national`;
    return $http.post(url, order);
  }

  function placeOrderForeign(order) {
    const url = `${basePath}/foreign`;
    return $http.post(url, order);
  }

  function completeOrder(id, conclusions) {
    const url = `${basePath}/${id}/complete`;
    return $http.put(url, {
      conclusions,
    });
  }

  function reopenOrder(id, message = null) {
    const url = `${basePath}/${id}/editing`;
    return $http.put(url, {
      message,
    });
  }

  function getOrderedCompaniesOverview(params) {
    const url = `${basePath}/summaries`;

    const formattedParams = {
      sort_by: params.sort_by,
      sort_dir: params.sort_dir,
      limit: params.limit || 10,
      page: params.page || 1,
    };
    const searchParamsObj = R.reduce(utils.withQueryParams, {}, R.toPairs(params.search));
    const sortPairs = R.filter(
      obj => !R.isNil(obj[1]) && !R.isEmpty(obj[1]),
      R.toPairs(params.sort || {}));

    const sortParamsObj = sortPairs.length > 0
      ? { sort_by: sortPairs[0][0], sort_dir: sortPairs[0][1] }
      : {};

    const completeParamObj = Object.assign({}, formattedParams, searchParamsObj, sortParamsObj);

    return $http.get(url, { params: completeParamObj });
  }

  function updateInvestigationCodes(orderId, investigation) {
    const url = `${basePath}/${orderId}/investigation`;
    return $http.put(url, {
      investigation_code: investigation.code,
      investigation_subcode: investigation.subcode,
    });
  }

  function downloadReport(orderId, userId, companyId, locale) {
    const token = localStorage.getItem('jwt_token');
    let tokenStr = '';
    if (token && isTokenValid(token) && !isTokenExpired(token)) {
      tokenStr = `&token=${token}`;
    }
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/orders/${orderId}/report?user_id=${userId}&company_id=${companyId}&locale=${locale}&type=attachment${tokenStr}`;
    return url;
  }

  function viewReportInBrowser(orderId, userId, companyId, locale) {
    const token = localStorage.getItem('jwt_token');
    let tokenStr = '';
    if (token && isTokenValid(token) && !isTokenExpired(token)) {
      tokenStr = `&token=${token}`;
    }
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/orders/${orderId}/report?user_id=${userId}&company_id=${companyId}&locale=${locale}&type=inline${tokenStr}`;
    return url;
  }

  return factory;
}
